'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Flippy = function Flippy(_ref) {
  var front = _ref.front,
      back = _ref.back,
      color = _ref.color,
      classNames = _ref.classNames;
  return _react2.default.createElement(
    'div',
    { className: 'c11n-flippy ' + classNames.root },
    _react2.default.createElement(
      'div',
      { className: classNames.wrapper + ' ' + classNames.front },
      front
    ),
    _react2.default.createElement(
      'div',
      { className: classNames.wrapper + ' ' + classNames.back },
      back
    )
  );
};

Flippy.propTypes = {
  /**
   * Content to appear by default
   */
  front: _propTypes2.default.node.isRequired,

  /**
   * Content to appear on hover
   */
  back: _propTypes2.default.node.isRequired,

  /**
   * The background color
   */
  background: _propTypes2.default.string,

  /**
   * The color of the text
   */
  foreground: _propTypes2.default.string,

  /**
   * The font for the text
   */
  font: _propTypes2.default.string,

  /**
   * The scale to be used for the font size
   */
  size: _propTypes2.default.number,

  /**
   * The spacing to be applied
   */
  spacing: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number]),

  /**
   * Custom styles to be applied
   */
  styles: _propTypes2.default.object
};

Flippy.defaultProps = {
  background: 'primary',
  foreground: 'light',
  font: 'body',
  size: 2,
  spacing: { x: 1, y: 1 },
  styles: {}
};

exports.default = (0, _withStyles2.default)(_styles2.default)(Flippy);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/flippy/index.js
// module id = 835
// module chunks = 0